module.exports = __webpack_public_path__ + "img/FPO.3db3589c.png";